import * as z from 'zod/mini';

export const PackageCalendarRequestSchema = z.object({
  package_id: z.number(),
  start_date: z.string(),
  end_date: z.string(),
  pax: z.number(),
  locale: z.string(),
  office_id: z.number(),
  department_id: z.number(),
});

const availabilitySchema = z.object({
  date: z.string(),
  price: z.nullish(z.number()),
  pricePerPerson: z.nullish(z.number()),
  availability: z.nullish(z.enum(['AV', 'RQ', 'NA', 'SS'])),
});

export const PackageCalendarResponseSchema = z.object({
  availabilities: z.array(availabilitySchema),
});
